import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { memo } from 'react';
import type { DonutChartProps as Props } from './types';

export const DonutChart = memo(({ options }: Props) => {
  return <HighchartsReact highcharts={Highcharts} options={options} />;
});

DonutChart.displayName = 'DonutChart';
